import { datatypes, inputTypes } from "data/globalData";

export const replJobsColumns = {
	user_email: {
		name: "Created By",
		key: "user_email",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 20,
		group: "",
		placeholder: "",
		default_value: "",
	},
	profile_id: {
		name: "Profile Id",
		key: "profile_id",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: "",
		placeholder: "",
		default_value: "",
	},

	job_id: {
		name: "Job Id",
		key: "job_id",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		group: "",
		placeholder: "",
		default_value: "",
	},
	// completed: {
	// 	name: "Status",
	// 	key: "completed",
	// 	input_type: inputTypes.AUTO_GENERATE.key,
	// 	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 0,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// },
};
